import { render, staticRenderFns } from "./after-sale.vue?vue&type=template&id=1219efca&"
import script from "./after-sale.vue?vue&type=script&lang=js&"
export * from "./after-sale.vue?vue&type=script&lang=js&"
import style0 from "./after-sale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports